/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Spin } from 'antd'
import React, { useEffect, useState } from 'react'

export default function ImageWithLoader({ src, style, onClick }) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (src) {
      setLoading(true)
    }
  }, [src])

  return (
    <>
      {loading && (
        <div style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin />
        </div>
      )}
      <img
        onClick={onClick}
        src={src}
        alt=""
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
        style={{
          display: loading ? 'none' : 'block',
          ...style,
        }}
      />
    </>
  )
}
